export default {
  props: {
    //百分比数
    percent: {
      type: [String, Number],
      default: 0
    },
    //进度动画速度
    speed: {
      type: [String, Number],
      default: 1
    },
    //环形进度条颜色
    borderColor: {
      type: String,
      default: '#00C1AE'
    },
    //环形进度条背景颜色
    borderBg: {
      type: String,
      default: '#fff'
    },
    //进度大小
    size: {
      type: [String, Number],
      default: 50
    },
    //环形进度条边框大小
    borderSize: {
      type: [String, Number],
      default: 4
    }
  },
  data() {
    return {
      //周长
      perimeter: (this.size / 2) * 2 * Math.PI,
      //进度开始
      perimeterStart: 0,
      //进度结束
      perimeterEnd: 0,
      //坐标
      xy: 0,
      //半径
      r: 0
    }
  },
  methods: {
    //初始化
    initialize() {
      this.perimeterStart = '0 ' + this.perimeter
      this.perimeterEnd = this.perimeter * (this.percent / 100) + ' ' + this.perimeter * ((100 - this.percent) / 100)
      this.xy = this.size / 2
      this.r = this.size / 2 - this.borderSize / 2
    }
  },
  created() {
    this.initialize()
  },
  mounted() {},
  watch: {
    percent() {
      this.initialize()
    }
  }
}